import { DoorOpen, Users, Link2 } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

const steps = [
  {
    n: "01",
    Icon: DoorOpen,
    title: "Step In",
    desc: "Arrive at any event or venue and check in to the live room — or open your own private room and share the code. No adding friends, no searching.",
    color: "violet",
  },
  {
    n: "02",
    Icon: Users,
    title: "Connect",
    desc: "See everyone who's here right now. Browse quick profiles, spot your kind of people, and send a connect with a single tap.",
    color: "cyan",
  },
  {
    n: "03",
    Icon: Link2,
    title: "Say Hi",
    desc: "Break the ice before the lights go down. Keep the conversation going long after the encore — and tonight's photos unlock at 9am, so you relive it over coffee, not mid-party.",
    color: "violet",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="relative py-24 md:py-32 overflow-hidden" data-testid="how-it-works">
      <div className="glow-orb w-[400px] h-[400px] bg-neon-violet/10 top-20 -right-20" />
      <div className="container-x relative z-10">
        <Reveal>
          <p className="overline mb-4">How it works</p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight max-w-2xl leading-none">
            Three taps from stranger to <span className="text-gradient">scene</span>.
          </h2>
        </Reveal>

        <Stagger className="mt-16 grid md:grid-cols-3 gap-6 relative">
          {/* connecting dashed line */}
          <div className="hidden md:block absolute top-[52px] left-[16%] right-[16%] h-px border-t border-dashed border-white/15" />
          {steps.map((s) => (
            <StaggerItem key={s.n}>
              <div className="relative glass rounded-2xl p-8 h-full hover:-translate-y-1.5 transition-transform duration-300 group">
                <div
                  className={`relative z-10 grid place-items-center w-14 h-14 rounded-2xl mb-6 ${
                    s.color === "violet"
                      ? "bg-neon-violet/15 text-neon-violet shadow-[0_0_30px_rgba(0,124,255,0.3)]"
                      : "bg-neon-cyan/15 text-neon-cyan shadow-[0_0_30px_rgba(0,198,174,0.3)]"
                  }`}
                >
                  <s.Icon className="w-7 h-7" />
                </div>
                <span className="font-display text-sm font-bold text-zinc-600">{s.n}</span>
                <h3 className="font-display text-2xl font-bold mt-1 mb-3">{s.title}</h3>
                <p className="text-zinc-400 leading-relaxed">{s.desc}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
